import React, { useRef } from 'react'

import './style.scss'
import { Dropdown, DropdownButton, FormLabel, Tab, Tabs } from 'react-bootstrap'
import { Range, getTrackBackground } from 'react-range'
import AppResource from 'general/constants/AppResource'
import CustomColorPicker from 'features/TemplateInvoice/components/CustomColorPicker'
import { useDispatch } from 'react-redux'
import {
  plusMinusFontSizeLineHeightAll,
  setActivePanel,
  setInstanceInfo,
  setLogoInfo,
  setShowWatermark,
  setSpecifiedDataField,
  setSpecifiedDataFieldProperty,
  setSpecifiedRegion,
  setWatermarkInfo,
} from 'features/TemplateInvoice/templateInvoiceSlice'
import { useSelector } from 'react-redux'
import { useColumnsDispatch } from 'features/TemplateInvoice/screens/CreateTemplateInvoice/ColumnsContext'
import { useState } from 'react'
import { useEffect } from 'react'
import Utils, { findObjectInArray } from 'general/utils/Utils'
import { TEMPLATE_FORM } from 'general/constants/AppConstants'
import TemplateInvoiceHelper from 'general/helpers/TemplateInvoiceHelper'
import templateInvoiceApi from 'api/templateInvoiceApi'
import ToastHelper from 'general/helpers/ToastHelper'
import TextFieldSelectBusinessBranch from 'general/components/Forms/TextFieldSelectBusinessBranch'
import { useFormik } from 'formik'
import BaseTextField from 'general/components/Forms/BaseTextField'
import { useAppSelector } from 'hooks/useRedux'
import { useQueryBusnessBranch } from 'general/components/Dropdown/CustomDropdown/queries'
import CustomSelect from 'general/components/CustomSelect'
import { AutoComplete } from 'antd'
import { useLocation } from 'react-router-dom'
import { InfoCircleOutlined } from '@ant-design/icons'
import KTTooltip from 'general/components/eInvoiceComponents/KTTooltip'

const displaySelectedLineType = (selectedLineType) => {
  switch (selectedLineType) {
    case 'solid':
    case 'dashed':
    case 'dotted':
      return (
        <div
          className="w-100 bg-transparent my-3"
          style={{
            height: '1px',
            borderBottom: `1px ${selectedLineType} black`,
          }}
        ></div>
      )
    case 'none':
    default:
      return 'Không có'
  }
}

const changeCKTemplateInvoiceSeries = (
  templateInvoiceSeries,
  templateInvoiceForm,
) => {
  templateInvoiceSeries = templateInvoiceSeries.split('')
  templateInvoiceSeries.splice(1, 1, templateInvoiceForm ? 'C' : 'K')
  return templateInvoiceSeries.join('')
}

function GeneralControl(props) {
  const {
    isBusinessInvoice,
    setIsBusinessInvoice,
    formik,
    templateInvoice,
    refGeneralSetting,
  } = props
  const dispatch = useDispatch()
  const columnsDispatch = useColumnsDispatch()
  const { style } = props

  const { showWatermark } = useSelector((state) => state.templateInvoice)
  const {
    templateInvoiceName,
    templateInvoiceForm,
    templateInvoiceSeries,
    dataTransferMethod,
    sellerInfoPosition,
    fontFamily,
    // fontSize,
    color,
    lineType,
    // lineHeight,
    isShowQRCode,
    duplicateInfoMulPages,
    isShowLabelEn,
    isShowWatermarkInAdjustedInvoice,
    isNonTariffArea,
    logoInfo,

    watermarkInfo,
    category,
    notDraftInvoices,
    isDeliveryInvoice,
    RegionConfigs,
    locationQr,
  } = useSelector((state) => state.templateInvoice.instance)

  // Cờ này bật để căn lại vị trí của logo sau khi đổi "Vị trí thông tin ngùoi bán"
  const [flag, setFlag] = useState(false)
  const [checkBoxShowMoToCar, setCheckBoxShowMoToCar] = useState(false)
  const { company } = useAppSelector((state) => state.system)
  const { pathname } = useLocation()
  useEffect(() => {
    if (flag) {
      ;(function reAlignLogoPosition() {
        setFlag(false)

        if (Utils.isObjectEmpty(logoInfo)) return
        const { width, height } = logoInfo

        let logoContainer = document.getElementById('logo-container')
        let containerWidth = logoContainer?.clientWidth
        let containerHeight = logoContainer?.clientHeight - 2

        let x = (containerWidth - width) / 2
        let y = (containerHeight - height) / 2

        dispatch(setLogoInfo({ ...logoInfo, x, y }))
      })()
    }
  }, [flag])

  useEffect(() => {
    dispatch(setShowWatermark(false))
  }, [])

  const setInvoiceInfoColumns = (payload) => {
    columnsDispatch({
      type: 'set',
      colsName: 'invoiceInfoColumns',
      payload,
    })
  }

  const setBuyerInfoColumns = (payload) => {
    columnsDispatch({
      type: 'set',
      colsName: 'buyerInfoColumns',
      payload,
    })
  }

  const [filterParams] = useState({
    page: 1,
    limit: 20,
    status: 'ACTIVE',
  })

  const { dataSource, isLoading, total, isRefetching, refetch } =
    useQueryBusnessBranch('', filterParams)

  console.log('dataSource', dataSource)

  const handleChangeTemplateInvoiceSeries = (e) => {
    dispatch(
      setInstanceInfo({
        templateInvoiceForm: parseInt(e.target.value),
        templateInvoiceSeries: changeCKTemplateInvoiceSeries(
          templateInvoiceSeries,
          parseInt(e.target.value),
        ),
      }),
    )
    dispatch(setInstanceInfo({ dataTransferMethod: '1' }))

    let fullSeries = changeCKTemplateInvoiceSeries(
      templateInvoiceSeries,
      parseInt(e.target.value),
    )
    dispatch(
      setSpecifiedDataFieldProperty({
        regionName: 'invoiceInfoOther',
        dataFieldName: 'invoiceSeries',
        propertyName: 'value',
        propertyData: {
          value: fullSeries,
        },
      }),
    )
  }

  const handleChangeLocationQr = (e) => {
    dispatch(
      setInstanceInfo({
        locationQr: e.target.value,
      }),
    )
    //  dispatch(
    //    setInstanceInfo({
    //      templateInvoiceForm: parseInt(e.target.value),
    //      templateInvoiceSeries: changeCKTemplateInvoiceSeries(
    //        templateInvoiceSeries,
    //        parseInt(e.target.value),
    //      ),
    //    }),
    //  )
    //  dispatch(setInstanceInfo({ dataTransferMethod: '1' }))

    //  let fullSeries = changeCKTemplateInvoiceSeries(
    //    templateInvoiceSeries,
    //    parseInt(e.target.value),
    //  )
    //  dispatch(
    //    setSpecifiedDataFieldProperty({
    //      regionName: 'invoiceInfoOther',
    //      dataFieldName: 'invoiceSeries',
    //      propertyName: 'value',
    //      propertyData: {
    //        value: fullSeries,
    //      },
    //    }),
    //  )
  }

  let oldBuyerInfoWidth = useRef()

  // const invoiceInfoRegion = useMemo(
  //   () => _.find(RegionConfigs, region => region.regionName === 'invoiceInfo'),
  //   [RegionConfigs],
  // )

  // const isNonTariffArea = useMemo(
  //   () =>
  //     invoiceInfoRegion?.regionConfigs?.find(
  //       ({ dataField }) => dataField == 'nonTariffArea',
  //     )?.show,
  //   [invoiceInfoRegion],
  // )

  useEffect(() => {
    TemplateInvoiceHelper.regionConfigsGroupByMergeFieldFunc2(
      RegionConfigs,
    )?.map(([mergeField, ...regionConfArr], index) => {
      if (regionConfArr?.[0]?.regionName == 'tableDetail') {
        let regionConfigs = regionConfArr?.[0]?.regionConfigs
        let regionConfigEngineNumber = findObjectInArray(
          regionConfigs,
          'dataField',
          'engineNumber',
        )
        setCheckBoxShowMoToCar(regionConfigEngineNumber?.show)
      }
    })
  }, [])

  const updateInvoiceTemplateFollowByBusiness = async () => {
    try {
      await templateInvoiceApi.updateInvoiceTemplateFollowByBusiness({
        invoiceTemplateId: Number(templateInvoiceId),
      })
      //gotDetailTemplateInvoice.current = false
      dispatch(
        setInstanceInfo({
          ...templateInvoiceInstance,
          isAppliedDecree70: true,
        }),
      )
      ToastHelper.showSuccess('Cập nhật mẫu hóa đơn theo NĐ 254 thành công')
    } catch (error) {
      // ToastHelper.showError(error.message)
    }
  }

  const updateBusinessBranchFields = (checkValue, data, checkbox) => {
    const sellerInfoRegion = RegionConfigs.find(
      (region) => region.regionName === 'sellerInfo',
    )

    if (!sellerInfoRegion) return

    const businessFields = [
      {
        dataField: 'businessBranchCode',
        label: 'Mã địa điểm kinh doanh',
        labelEn: '(Business Branch Code)',
      },
      {
        dataField: 'businessBranchName',
        label: 'Tên địa điểm kinh doanh',
        labelEn: '(Business Branch Name)',
      },
      {
        dataField: 'businessBranchAddress',
        label: 'Địa chỉ địa điểm kinh doanh',
        labelEn: '(Business Branch Address)',
      },
    ]

    const updatedRegionConfigs = [...sellerInfoRegion.regionConfigs]

    businessFields.forEach((item) => {
      const index = updatedRegionConfigs.findIndex(
        (field) => field.dataField === item.dataField,
      )

      if (index !== -1) {
        // Đã có -> cập nhật show
        updatedRegionConfigs[index] = {
          ...updatedRegionConfigs[index],
          ...(checkbox
            ? checkValue
              ? { show: 1 }
              : { show: 0 }
            : checkValue
              ? {}
              : {}),
          // ...(checkValue ? {} : { show: 0 }),
          value: {
            value: data?.[item.dataField],
            editable: false,
          },
        }
      } else {
        // Chưa có -> thêm mới
        updatedRegionConfigs.push({
          dataField: item.dataField,
          label: {
            value: item.label,
          },
          labelEn: {
            fontStyle: 'italic',
            value: item.labelEn,
          },
          value: {
            value: data?.[item.dataField],
            editable: false,
          },
          show: checkValue ? 1 : 0,
          children: [],
        })
      }
    })
    dispatch(
      setSpecifiedRegion({
        regionName: 'sellerInfo',
        propertyData: {
          regionConfigs: updatedRegionConfigs,
        },
      }),
    )
  }

  const handleSelectBusinessBranch = (businessBranch) => {
    console.log('businessBranch', businessBranch)
    formik.setFieldValue(
      'businessBranchCode',
      businessBranch?.businessBranchCode ?? '',
    )
    formik.setFieldValue(
      'businessBranchName',
      businessBranch?.businessBranchName ?? '',
    )
    formik.setFieldValue(
      'businessBranchAddress',
      businessBranch?.businessBranchAddress ?? '',
    )
    updateBusinessBranchFields(isBusinessInvoice, {
      businessBranchCode: businessBranch?.businessBranchCode ?? '',
      businessBranchName: businessBranch?.businessBranchName ?? '',
      businessBranchAddress: businessBranch?.businessBranchAddress ?? '',
    })
  }

  useEffect(() => {
    setIsBusinessInvoice(templateInvoice?.useBusinessBranch)
    formik.setFieldValue(
      'businessBranchCode',
      templateInvoice?.businessBranchCode ?? '',
    )
    formik.setFieldValue(
      'businessBranchName',
      templateInvoice?.businessBranchName ?? '',
    )
    formik.setFieldValue(
      'businessBranchAddress',
      templateInvoice?.businessBranchAddress ?? '',
    )
    updateBusinessBranchFields(templateInvoice?.useBusinessBranch, {
      businessBranchCode: templateInvoice?.useBusinessBranch
        ? (templateInvoice?.businessBranchCode ?? '')
        : null,
      businessBranchName: templateInvoice?.useBusinessBranch
        ? (templateInvoice?.businessBranchName ?? '')
        : null,
      businessBranchAddress: templateInvoice?.useBusinessBranch
        ? (templateInvoice?.businessBranchAddress ?? '')
        : null,
    })
  }, [templateInvoice?.invoiceTemplateId])

  return (
    <div
      className="GeneralControl d-flex flex-column"
      style={{ ...style, overflowY: 'hidden', overflowX: 'visible' }}
    >
      <div
        className="d-flex flex-row align-items-center mb-3"
        style={{ flex: '0 1 auto' }}
      >
        <button
          type="button"
          className="btn btn-icon mr-2 cursor-pointer"
          onClick={() => {
            dispatch(setActivePanel('main_ctrl'))
          }}
        >
          <i className="fas fa-arrow-left" style={{ color: '#000000' }}></i>
        </button>
        <h3 className="static-title">Thiết lập thông tin chung</h3>
      </div>

      <div
        className=""
        style={{ flex: '1 1 auto', overflowY: 'scroll', overflowX: 'visible' }}
      >
        <div className="row mx-0 g-2 mb-5">
          <div className="col-12 px-0">
            <label htmlFor="template-inv-name" className="form-label">
              Tên mẫu
              <span className="ml-1" style={{ color: 'red' }}>
                *
              </span>
            </label>
            <input
              type="text"
              className="form-control"
              id="template-inv-name"
              // defaultValue="Hóa đơn GTGT test"
              value={templateInvoiceName}
              disabled={notDraftInvoices?.length}
              onChange={(e) =>
                dispatch(
                  setInstanceInfo({ templateInvoiceName: e.target.value }),
                )
              }
            />
          </div>

          <div className="col-12 px-0">
            <p className="mb-0">
              Hình thức hóa đơn
              <span className="ml-1" style={{ color: 'red' }}>
                *
              </span>
            </p>
          </div>

          <div className="col-6 px-0">
            <div className="d-flex flex-row align-items-center cursor-pointer">
              <input
                className="mr-3 cursor-pointer"
                type="radio"
                name="templateInvoiceSeries"
                id="have-authen-code"
                checked={templateInvoiceForm == 1}
                disabled={notDraftInvoices?.length}
                value={1}
                onChange={handleChangeTemplateInvoiceSeries}
                style={{ width: '1.2rem', height: '1.2rem' }}
              />
              <label className="m-0 cursor-pointer" htmlFor="have-authen-code">
                HĐ có mã của CQT
              </label>
            </div>
          </div>
          <div className="col-6 px-0">
            <div className="d-flex flex-row align-items-center cursor-pointer mb-2">
              <input
                className="mr-3 cursor-pointer"
                type="radio"
                name="templateInvoiceSeries"
                id="not-have-authen-code"
                checked={templateInvoiceForm == 0}
                disabled={notDraftInvoices?.length}
                value={0}
                // onChange={e => {
                //   dispatch(
                //     setInstanceInfo({
                //       templateInvoiceForm: parseInt(e.target.value),
                //       templateInvoiceSeries: changeCKTemplateInvoiceSeries(
                //         templateInvoiceSeries,
                //         parseInt(e.target.value),
                //       ),
                //     }),
                //   )
                // }}
                onChange={handleChangeTemplateInvoiceSeries}
                style={{ width: '1.2rem', height: '1.2rem' }}
              />
              <label
                className="m-0 cursor-pointer"
                htmlFor="not-have-authen-code"
              >
                HĐ không có mã của CQT
              </label>
            </div>
          </div>

          <div className="col-12 px-0">
            <p className="mb-0 d-flex align-items-center">
              Ký hiệu
              <span className="ml-1" style={{ color: 'red' }}>
                *
              </span>
              <KTTooltip
                overlayClassname="KTTooltipOverlay--wide"
                text="Nếu đã từng phát hành hóa đơn điện tử trên phần mềm của nhà cung cấp khác, vui lòng nhập ký hiệu KHÁC với ký hiệu đã dùng trước đây để đảm bảo hóa đơn điện tử gửi đến cơ quan thuế hợp lệ."
              >
                <span
                  className="ml-1"
                  style={{ display: 'inline-flex', cursor: 'pointer' }}
                >
                  <InfoCircleOutlined style={{ color: '#3478f6' }} />
                </span>
              </KTTooltip>
            </p>
          </div>

          <div className="d-flex flex-row align-items-center cursor-pointer">
            <input
              className="mr-3 cursor-pointer"
              type="checkbox"
              id="show-moto-car"
              checked={checkBoxShowMoToCar}
              onChange={async (e) => {
                // let checkValue = e.target.checked
                // alert('dsdss')
                TemplateInvoiceHelper.regionConfigsGroupByMergeFieldFunc2(
                  RegionConfigs,
                )?.map(([mergeField, ...regionConfArr], index) => {
                  if (regionConfArr?.[0]?.regionName == 'tableDetail') {
                    let regionConfigs = regionConfArr?.[0]?.regionConfigs
                    let regionConfigEngineNumber = findObjectInArray(
                      regionConfigs,
                      'dataField',
                      'engineNumber',
                    )
                    let regionConfigcChassisNumber = findObjectInArray(
                      regionConfigs,
                      'dataField',
                      'chassisNumber',
                    )
                    dispatch(
                      setSpecifiedDataField({
                        regionName: regionConfArr?.[0]?.regionName,
                        dataFieldName: regionConfigEngineNumber.dataField,
                        propertyData: {
                          show: !checkBoxShowMoToCar,
                        },
                      }),
                    )
                    dispatch(
                      setSpecifiedDataField({
                        regionName: regionConfArr?.[0]?.regionName,
                        dataFieldName: regionConfigcChassisNumber.dataField,
                        propertyData: {
                          show: !checkBoxShowMoToCar,
                        },
                      }),
                    )
                    setCheckBoxShowMoToCar(!checkBoxShowMoToCar)
                  }
                })
              }}
              style={{ width: '1.2rem', height: '1.2rem' }}
            />
            <label className="m-0 cursor-pointer" htmlFor="show-moto-car">
              Có phát sinh hàng hóa là xe ô tô, mô tô
            </label>
          </div>

          <div className="col-12 px-0">
            <div className="input-group mb-3">
              <span className="input-group-text" id="template-invoice-series">
                {templateInvoiceSeries?.slice(0, 5)}
              </span>
              <input
                type="text"
                className="form-control"
                aria-describedby="template-invoice-series"
                disabled={notDraftInvoices?.length}
                value={templateInvoiceSeries?.slice(5)}
                onChange={(e) => {
                  let newTemplateInvoiceSeries =
                    templateInvoiceSeries?.slice(0, 5) + e.target.value
                  dispatch(
                    setInstanceInfo({
                      templateInvoiceSeries: newTemplateInvoiceSeries,
                    }),
                  )
                  dispatch(
                    setSpecifiedDataFieldProperty({
                      regionName: 'invoiceInfoOther',
                      dataFieldName: 'invoiceSeries',
                      propertyName: 'value',
                      propertyData: {
                        value: newTemplateInvoiceSeries,
                      },
                    }),
                  )
                }}
                style={{ flex: '0 0 50px', padding: '0.65rem 0.85rem' }}
              />
            </div>
          </div>
          {[TEMPLATE_FORM.INVOICE_VAT, TEMPLATE_FORM.INVOICE_FOR_SALE].includes(
            category?.form,
          ) && (
            <div className="col-12 px-0">
              <div className="d-flex flex-row align-items-center cursor-pointer">
                <input
                  className="mr-3 cursor-pointer"
                  type="checkbox"
                  id="delivery-service-invoice"
                  checked={isDeliveryInvoice}
                  onChange={(e) => {
                    let checkValue = e.target.checked
                    dispatch(setInstanceInfo({ isDeliveryInvoice: checkValue }))
                    const tableDetailRegion = RegionConfigs.find(
                      (region) => region.regionName == 'tableDetail',
                    )
                    const tableDetail1Region = RegionConfigs.find(
                      (region) => region.regionName == 'tableDetail1',
                    )
                    const updatedRegionConfigs =
                      tableDetailRegion.regionConfigs.map((field) => {
                        if (field.dataField === 'plateNumber') {
                          return { ...field, show: checkValue ? 1 : 0 } // tạo object mới
                        }
                        return field // giữ nguyên
                      })
                    dispatch(
                      setSpecifiedRegion({
                        regionName: 'tableDetail',
                        propertyData: {
                          regionConfigs: updatedRegionConfigs
                            .flat()
                            .filter((item) => typeof item !== 'string'),
                        },
                      }),
                    )
                    const updatedRegion1Configs =
                      tableDetail1Region.regionConfigs.map((field) => {
                        if (field.dataField === 'plateNumber') {
                          return { ...field, show: checkValue ? 1 : 0 } // tạo object mới
                        }
                        return field // giữ nguyên
                      })
                    dispatch(
                      setSpecifiedRegion({
                        regionName: 'tableDetail1',
                        propertyData: {
                          regionConfigs: updatedRegion1Configs
                            .flat()
                            .filter((item) => typeof item !== 'string'),
                        },
                      }),
                    )
                  }}
                  style={{ width: '1.2rem', height: '1.2rem' }}
                />
                <label
                  className="m-0 cursor-pointer"
                  htmlFor="delivery-service-invoice"
                >
                  Là hóa đơn đặc trưng dịch vụ vận chuyển
                </label>
                <KTTooltip
                  overlayClassname="KTTooltipOverlay--wide"
                  text="Tích chọn “Là hóa đơn đặc trưng dịch vụ vận chuyển” đối với hóa đơn dùng cho dịch vụ vận tải đường bộ trong nước. Theo quy định, các thông tin đặc trưng bao gồm: Biển kiểm soát, Điểm đi, Điểm đến."
                >
                  <span
                    className="ml-1"
                    style={{ display: 'inline-flex', cursor: 'pointer' }}
                  >
                    <InfoCircleOutlined style={{ color: '#3478f6' }} />
                  </span>
                </KTTooltip>
              </div>
            </div>
          )}

          <div className="col-12 px-0" ref={refGeneralSetting}>
            <div className="d-flex flex-row align-items-center cursor-pointer">
              <input
                className="mr-3 cursor-pointer"
                type="checkbox"
                id="business-service-invoice"
                checked={isBusinessInvoice}
                onChange={(e) => {
                  const checkValue = e.target.checked
                  setIsBusinessInvoice(checkValue)
                  const branchInfo = pathname.includes('/tao/')
                    ? company
                    : templateInvoice?.businessBranchCode
                      ? templateInvoice
                      : company

                  const businessBranchCode =
                    branchInfo?.businessBranchCode ?? ''
                  const businessBranchName =
                    branchInfo?.businessBranchName ?? ''
                  const businessBranchAddress =
                    branchInfo?.businessBranchAddress ?? ''
                  console.log('branchInfo', branchInfo)

                  formik.setFieldValue('businessBranchCode', businessBranchCode)
                  formik.setFieldValue('businessBranchName', businessBranchName)
                  formik.setFieldValue(
                    'businessBranchAddress',
                    businessBranchAddress,
                  )

                  updateBusinessBranchFields(
                    checkValue,
                    {
                      businessBranchCode: businessBranchCode || null,
                      businessBranchName: businessBranchName || null,
                      businessBranchAddress: businessBranchAddress || null,
                    },
                    1,
                  )
                }}
                style={{ width: '1.2rem', height: '1.2rem' }}
              />
              <label
                className="m-0 cursor-pointer"
                htmlFor="business-service-invoice"
              >
                Thiết lập thông tin địa điểm kinh doanh
              </label>
              <KTTooltip
                overlayClassname="KTTooltipOverlay--wide"
                text="Hộ kinh doanh, cá nhân kinh doanh, doanh nghiệp kinh doanh xăng dầu thiết lập tùy chọn này để hiển thị thông tin địa điểm kinh doanh lên hóa đơn theo quy định hiện hành."
              >
                <span
                  className="ml-1"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    alignSelf: 'center',
                    cursor: 'pointer',
                  }}
                >
                  <InfoCircleOutlined style={{ color: '#3478f6' }} />
                </span>
              </KTTooltip>
            </div>
            {isBusinessInvoice ? (
              <div className="container" style={{ marginTop: 5 }}>
                <FormLabel>
                  <b>Mã địa điểm kinh doanh</b>
                </FormLabel>
                <div className="w-100">
                  {/* <TextFieldSelectBusinessBranch
                    className="flex-grow-1 w-100"
                    fieldHelper={formik.getFieldHelpers('businessBranchCode')}
                    fieldMeta={formik.getFieldMeta('businessBranchCode')}
                    fieldProps={formik.getFieldProps('businessBranchCode')}
                    onCreateNew={() => {
                      // setShowingModalEditCustomer(true)
                    }}
                    onSelect={handleSelectBusinessBranch}
                  /> */}
                  <AutoComplete
                    value={formik.values.businessBranchCode}
                    style={{ width: '100%', height: 40 }}
                    options={dataSource.map((item) => ({
                      value: item.businessBranchCode,
                      label: item.businessBranchName,
                    }))}
                    placeholder="Nhập hoặc chọn mã địa điểm kinh doanh"
                    onChange={(value) => {
                      // Chỉ cập nhật text đang nhập
                      formik.setFieldValue('businessBranchCode', value)
                      updateBusinessBranchFields(isBusinessInvoice, {
                        businessBranchCode: value,
                        businessBranchName:
                          formik.getFieldProps('businessBranchName').value,
                        businessBranchAddress: formik.getFieldProps(
                          'businessBranchAddress',
                        ).value,
                      })
                    }}
                    onSelect={(value) => {
                      // Chỉ khi chọn từ dropdown mới lấy dữ liệu
                      const data = findObjectInArray(
                        dataSource,
                        'businessBranchCode',
                        value,
                      )

                      handleSelectBusinessBranch(data)
                    }}
                    onClick={() => {
                      refetch()
                    }}
                  />
                </div>
                <div className="w-100" style={{ marginTop: 5 }}>
                  <FormLabel>
                    <b>Tên địa điểm kinh doanh</b>
                  </FormLabel>
                  <div className="w-100">
                    <BaseTextField
                      className="flex-grow-1 w-100"
                      name="businessBranchName"
                      fieldProps={formik.getFieldProps('businessBranchName')}
                      fieldMeta={formik.getFieldMeta('businessBranchName')}
                      fieldHelper={formik.getFieldHelpers('businessBranchName')}
                      onBlur={(e) => {
                        updateBusinessBranchFields(isBusinessInvoice, {
                          businessBranchCode:
                            formik.getFieldProps('businessBranchCode').value,
                          businessBranchName: e.target.value,
                          businessBranchAddress: formik.getFieldProps(
                            'businessBranchAddress',
                          ).value,
                        })
                      }}
                    />
                  </div>
                </div>
                <div className="w-100" style={{ marginTop: 5 }}>
                  <FormLabel>
                    <b>Địa chỉ địa điểm kinh doanh</b>
                  </FormLabel>
                  <div className="w-100">
                    <BaseTextField
                      className="flex-grow-1 w-100"
                      name="businessBranchAddress"
                      fieldProps={formik.getFieldProps('businessBranchAddress')}
                      fieldMeta={formik.getFieldMeta('businessBranchAddress')}
                      fieldHelper={formik.getFieldHelpers(
                        'businessBranchAddress',
                      )}
                      onBlur={(e) => {
                        updateBusinessBranchFields(isBusinessInvoice, {
                          businessBranchCode:
                            formik.getFieldProps('businessBranchCode').value,
                          businessBranchName:
                            formik.getFieldProps('businessBranchName').value,
                          businessBranchAddress: e.target.value,
                        })
                      }}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>

          {category?.form == 2 && (
            <div className="col-12 px-0">
              <div className="d-flex flex-row align-items-center cursor-pointer">
                <input
                  className="mr-3 cursor-pointer"
                  type="checkbox"
                  id="is-non-tariff-area"
                  checked={isNonTariffArea}
                  onChange={(e) => {
                    dispatch(
                      setInstanceInfo({
                        isNonTariffArea: e.target.checked,
                      }),
                    )
                    dispatch(
                      dispatch(
                        setSpecifiedDataField({
                          regionName: 'invoiceInfo',
                          dataFieldName: 'nonTariffArea',
                          propertyData: { show: e.target.checked ? 1 : 0 },
                        }),
                      ),
                    )
                  }}
                  style={{ width: '1.2rem', height: '1.2rem' }}
                />
                <label
                  className="m-0 cursor-pointer"
                  htmlFor="is-non-tariff-area"
                >
                  Là hóa đơn dành cho khu phi thuế quan
                </label>
              </div>
            </div>
          )}

          {templateInvoiceSeries[1] == 'K' && (
            <>
              <div className="col-12 px-0">
                <p className="mb-0">
                  Phương thức chuyển dữ liệu đến CQT
                  <span className="ml-1" style={{ color: 'red' }}>
                    *
                  </span>
                </p>
              </div>

              <div className="col-12 px-0">
                <div className="d-flex flex-row align-items-center cursor-pointer">
                  <input
                    className="mr-3 cursor-pointer"
                    type="radio"
                    name="dataTransferMethod"
                    id="full-content"
                    checked={dataTransferMethod === '1'}
                    onChange={(e) => {
                      if (e.target.checked) {
                        dispatch(setInstanceInfo({ dataTransferMethod: '1' }))
                      }
                    }}
                    style={{ width: '1.2rem', height: '1.2rem' }}
                  />
                  <label className="m-0 cursor-pointer" htmlFor="full-content">
                    Chuyển đầy đủ nội dung từng hóa đơn
                  </label>
                </div>
              </div>
              <div className="col-12 px-0">
                <div className="d-flex flex-row align-items-center cursor-pointer mb-2">
                  <input
                    className="mr-3 cursor-pointer"
                    type="radio"
                    name="dataTransferMethod"
                    id="summary-table"
                    checked={
                      dataTransferMethod === '2' || dataTransferMethod === '3'
                    }
                    onChange={(e) => {
                      if (e.target.checked) {
                        dispatch(setInstanceInfo({ dataTransferMethod: '2' }))
                      }
                    }}
                    style={{ width: '1.2rem', height: '1.2rem' }}
                  />
                  <label className="m-0 cursor-pointer" htmlFor="summary-table">
                    Chuyển theo bảng tổng hợp dữ liệu hoá đơn điện tử
                  </label>
                </div>
                {(() => {
                  switch (category?.form) {
                    case 3:
                      return <></>
                    default:
                      return (
                        <>
                          {dataTransferMethod != '1' && (
                            <div className="d-flex flex-row align-items-center cursor-pointer ml-15">
                              <div className="d-flex flex-row align-items-center cursor-pointer mr-5">
                                <input
                                  className="mr-3 cursor-pointer"
                                  type="radio"
                                  name="dataTransferMethod2"
                                  id="summary-table-petro"
                                  checked={dataTransferMethod === '2'}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      dispatch(
                                        setInstanceInfo({
                                          dataTransferMethod: '2',
                                        }),
                                      )
                                    }
                                  }}
                                  style={{ width: '1.2rem', height: '1.2rem' }}
                                />
                                <label
                                  className="m-0 cursor-pointer"
                                  htmlFor="summary-table-petro"
                                >
                                  Xăng dầu
                                </label>
                              </div>
                              <div className="d-flex flex-row align-items-center cursor-pointer">
                                <input
                                  className="mr-3 cursor-pointer"
                                  type="radio"
                                  name="dataTransferMethod2"
                                  id="summary-table-other"
                                  checked={dataTransferMethod === '3'}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      dispatch(
                                        setInstanceInfo({
                                          dataTransferMethod: '3',
                                        }),
                                      )
                                    }
                                  }}
                                  style={{ width: '1.2rem', height: '1.2rem' }}
                                />
                                <label
                                  className="m-0 cursor-pointer"
                                  htmlFor="summary-table-other"
                                >
                                  Khác
                                </label>
                              </div>
                            </div>
                          )}
                        </>
                      )
                  }
                })()}
              </div>
            </>
          )}

          {(() => {
            switch (category?.form) {
              case 3:
                return (
                  <div className="col-12 px-0">
                    <div className="d-flex flex-row bg-light p-3 ml-5">
                      <div className="mr-4 mt-1">
                        <i
                          className="fa-solid fa-lightbulb-on fa-lg"
                          style={{ color: '#efd358' }}
                        ></i>
                      </div>
                      <div className="remind">
                        {dataTransferMethod == '1' ? (
                          <div className="mb-0">
                            Hóa đơn được lập với mẫu này sẽ được chuyển dữ liệu
                            đến cơ quan thuế ngay sau khi gửi hóa đơn cho người
                            mua.
                            <br />
                            Xem chi tiết{' '}
                            <a href="#" target="_blank">
                              tại đây
                            </a>
                          </div>
                        ) : (
                          <div className="mb-0">
                            Hóa đơn được lập với mẫu này sẽ được chuyển dữ liệu
                            đến cơ quan thuế theo bảng tổng hợp dữ liệu hóa đơn
                            điện tử.
                            <br />
                            Xem chi tiết{' '}
                            <a href="#" target="_blank">
                              tại đây
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )
              default:
                return (
                  <div className="col-12 px-0">
                    <div className="d-flex flex-row bg-light p-3 ml-5">
                      <div className="mr-4 mt-1">
                        <i
                          className="fa-solid fa-lightbulb-on fa-lg"
                          style={{ color: '#efd358' }}
                        ></i>
                      </div>
                      <div className="remind">
                        {dataTransferMethod == '1' ? (
                          <div className="mb-0">
                            Hóa đơn được lập với mẫu này sẽ được chuyển dữ liệu
                            đến cơ quan thuế ngay sau khi gửi hóa đơn cho người
                            mua. <br />
                            Xem chi tiết{' '}
                            <a href="#" target="_blank">
                              tại đây
                            </a>
                          </div>
                        ) : dataTransferMethod == '2' ? (
                          <div className="mb-0">
                            Hóa đơn được lập với mẫu này cần chuyển dữ liệu đến
                            CQT theo <b>Bảng tổng hợp dữ liệu HĐĐT</b> dành cho
                            lĩnh vực <b>Xăng dầu</b> trong <b>ngày.</b> <br />
                            Xem chi tiết{' '}
                            <a href="#" target="_blank">
                              tại đây
                            </a>
                          </div>
                        ) : (
                          <div className="mb-0">
                            Hóa đơn được lập với mẫu này cần chuyển dữ liệu đến
                            CQT theo <b>Bảng tổng hợp dữ liệu HĐĐT</b> dành cho
                            lĩnh vực <b>Khác</b> theo{' '}
                            <b>kỳ kê khai thuế GTGT.</b> <br />
                            Xem chi tiết{' '}
                            <a href="#" target="_blank">
                              tại đây
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )
            }
          })()}
        </div>

        {(() => {
          switch (category?.form) {
            case 3:
              return <></>
            default:
              return (
                <>
                  <p className="mt-5 mb-3 font-sfpro-bold">
                    Vị trí thông tin người bán
                  </p>

                  <div>
                    <Tabs
                      activeKey={sellerInfoPosition}
                      onSelect={(k) => {
                        dispatch(setInstanceInfo({ sellerInfoPosition: k }))

                        setInvoiceInfoColumns([
                          {
                            title: '',
                            dataIndex: 'col1',
                            key: 'col1',
                            width: k == 1 ? 123 : k == 2 ? 80 : 250,
                          },
                          {
                            title: '',
                            dataIndex: 'col2',
                            key: 'col2',
                            width: k == 1 ? 415 : k == 2 ? 320 : 158,
                          },
                          { title: '', dataIndex: 'col3', key: 'col3' },
                        ])

                        setFlag(true)
                      }}
                      className="d-inline-flex mx-auto mb-3"
                    >
                      <Tab eventKey={1} title="Vị trí 1"></Tab>
                      <Tab eventKey={2} title="Vị trí 2"></Tab>
                      <Tab eventKey={3} title="Vị trí 3"></Tab>
                    </Tabs>
                  </div>
                </>
              )
          }
        })()}

        <div className="p-3 mb-4 border">
          <div className="d-flex flex-row align-items-center mb-2">
            <div
              className="font-sfpro-bold mr-2"
              style={{ fontSize: '24px', color: 'dodgerblue' }}
            >
              A
            </div>
            <p className="mb-0">
              Thay đổi font chữ, cỡ chữ, chiều cao giữa các dòng
            </p>
          </div>

          <div className="d-flex flex-row">
            <div className="d-flex flex-column mr-5" style={{ width: '160px' }}>
              <div>Font chữ</div>
              <div>
                <DropdownButton
                  title={fontFamily}
                  onSelect={(k) => dispatch(setInstanceInfo({ fontFamily: k }))}
                  className="w-100"
                >
                  <Dropdown.Item eventKey="Roboto">Roboto</Dropdown.Item>
                  <Dropdown.Item eventKey="Arial">Arial</Dropdown.Item>
                  <Dropdown.Item eventKey="Times New Roman">
                    Times New Roman
                  </Dropdown.Item>
                </DropdownButton>
              </div>
            </div>

            <div className="d-flex flex-column mr-5">
              <div>Cỡ chữ</div>
              <div className="d-flex flex-row">
                <div
                  className="fontsize-up mr-2 active-border-blue"
                  onClick={() =>
                    dispatch(
                      plusMinusFontSizeLineHeightAll({
                        func: 'PLUS',
                        propertyName: 'fontSize',
                      }),
                    )
                  }
                >
                  A+
                </div>
                <div
                  className="fontsize-down active-border-blue"
                  onClick={() =>
                    dispatch(
                      plusMinusFontSizeLineHeightAll({
                        func: 'MINUS',
                        propertyName: 'fontSize',
                      }),
                    )
                  }
                >
                  A-
                </div>
              </div>
            </div>

            <div className="d-flex flex-column mr-5" style={{ width: '100px' }}>
              <div>Màu chữ</div>
              <div>
                <CustomColorPicker
                  selectedColor={color}
                  setSelectedColor={(value) =>
                    dispatch(setInstanceInfo({ color: value }))
                  }
                />
              </div>
            </div>
          </div>

          <div className="d-flex flex-row">
            <div className="d-flex flex-column mr-5" style={{ width: '160px' }}>
              <div>Loại dòng kẻ trên bảng</div>
              <div>
                <DropdownButton
                  title={displaySelectedLineType(lineType)}
                  onSelect={(lt) => dispatch(setInstanceInfo({ lineType: lt }))}
                  className="w-100"
                >
                  <Dropdown.Item eventKey="solid">
                    <div
                      className="w-100 bg-transparent my-3"
                      style={{
                        height: '1px',
                        borderBottom: '1px solid black',
                      }}
                    ></div>
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="dashed">
                    <div
                      className="w-100 bg-transparent my-3"
                      style={{
                        height: '1px',
                        borderBottom: '1px dashed black',
                      }}
                    ></div>
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="dotted">
                    <div
                      className="w-100 bg-transparent my-3"
                      style={{
                        height: '1px',
                        borderBottom: '1px dotted black',
                      }}
                    ></div>
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="none">Không có</Dropdown.Item>
                </DropdownButton>
              </div>
            </div>

            <div className="d-flex flex-column mr-5">
              <div>Chiều cao giữa các dòng</div>
              <div className="d-flex flex-row">
                <div className="lineheight-up mr-2 active-border-blue">
                  <div
                    onClick={() =>
                      dispatch(
                        plusMinusFontSizeLineHeightAll({
                          func: 'PLUS',
                          propertyName: 'lineHeight',
                        }),
                      )
                    }
                    style={{
                      backgroundImage: `url(${AppResource.icons.icLineHeightUp.default})`,
                    }}
                  ></div>
                </div>
                <div className="lineheight-down active-border-blue">
                  <div
                    style={{
                      backgroundImage: `url(${AppResource.icons.icLineHeightDown.default})`,
                    }}
                    onClick={() =>
                      dispatch(
                        plusMinusFontSizeLineHeightAll({
                          func: 'MINUS',
                          propertyName: 'lineHeight',
                        }),
                      )
                    }
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row mx-0 g-3 mb-5">
          <div className="col-12 px-0">
            <div className="d-flex flex-row align-items-center cursor-pointer">
              <input
                className="mr-3 cursor-pointer"
                type="checkbox"
                id="show-qr-code"
                checked={isShowQRCode}
                onChange={(e) => {
                  let checkValue = e.target.checked
                  dispatch(setInstanceInfo({ isShowQRCode: checkValue }))
                  if (!checkValue) {
                    let oldWidth =
                      document.getElementById('buyerInfoContent')
                        ?.offsetWidth || 600
                    oldBuyerInfoWidth.current = oldWidth

                    setBuyerInfoColumns((old) => [
                      ...old.map((column) =>
                        column.width
                          ? { ...column, width: undefined }
                          : { ...column, width: 0.5 },
                      ),
                    ])
                  } else {
                    setBuyerInfoColumns((old) => [
                      ...old.map((column) =>
                        column.width
                          ? { ...column, width: undefined }
                          : {
                              ...column,
                              width: oldBuyerInfoWidth.current || 600,
                            },
                      ),
                    ])
                  }
                }}
                style={{ width: '1.2rem', height: '1.2rem' }}
              />
              <label className="m-0 cursor-pointer" htmlFor="show-qr-code">
                Hiển thị QR code
              </label>
            </div>
            {(() => {
              switch (category?.form) {
                case 3:
                  return (
                    <>
                      {isShowQRCode && (
                        <div className="row mx-0 g-3 mt-1">
                          <div className="col-1 px-0"></div>
                          <div className="col px-0">
                            <div className="d-flex flex-row align-items-center cursor-pointer">
                              <input
                                className="mr-3 cursor-pointer"
                                type="radio"
                                name="locationQr"
                                id="locationQrSellerInfo"
                                checked={locationQr == 'sellerInfo'}
                                value={'sellerInfo'}
                                onChange={handleChangeLocationQr}
                                style={{ width: '1.2rem', height: '1.2rem' }}
                              />
                              <label
                                className="m-0 cursor-pointer"
                                htmlFor="locationQrSellerInfo"
                              >
                                TT người bán
                              </label>
                            </div>
                          </div>
                          <div className="col px-0">
                            <div className="d-flex flex-row align-items-center cursor-pointer mb-2">
                              <input
                                className="mr-3 cursor-pointer"
                                type="radio"
                                name="locationQr"
                                id="locationQrBuyerInfo"
                                checked={
                                  !locationQr || locationQr == 'buyerInfo'
                                }
                                value={null}
                                onChange={handleChangeLocationQr}
                                style={{ width: '1.2rem', height: '1.2rem' }}
                              />
                              <label
                                className="m-0 cursor-pointer"
                                htmlFor="locationQrBuyerInfo"
                              >
                                TT người mua
                              </label>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )
                default:
                  return <></>
              }
            })()}
          </div>
          <div className="col-12 px-0">
            <div className="d-flex flex-row align-items-center cursor-pointer">
              <input
                className="mr-3 cursor-pointer"
                type="checkbox"
                id="duplicate-info-mul-page"
                checked={duplicateInfoMulPages}
                onChange={(e) =>
                  dispatch(
                    setInstanceInfo({
                      duplicateInfoMulPages: e.target.checked,
                    }),
                  )
                }
                style={{ width: '1.2rem', height: '1.2rem' }}
              />
              <label
                className="m-0 cursor-pointer"
                htmlFor="duplicate-info-mul-page"
              >
                Lặp lại thông tin hóa đơn trên nhiều trang
              </label>
            </div>
          </div>
          <div className="col-12 px-0">
            <div className="d-flex flex-row align-items-center cursor-pointer">
              <input
                className="mr-3 cursor-pointer"
                type="checkbox"
                id="show-label-en"
                checked={isShowLabelEn}
                onChange={(e) => {
                  dispatch(setInstanceInfo({ isShowLabelEn: e.target.checked }))

                  let dateString = e.target.checked
                    ? 'Ngày (Date)   tháng (month)   năm (year)   '
                    : 'Ngày   tháng   năm   '
                  const dates = [
                    {
                      regionName: 'invoiceInfo',
                      dataFieldName: 'dateInvoice',
                    },
                    {
                      regionName: 'buyerInfo',
                      dataFieldName: 'deliveryOrderDate',
                    },
                  ]
                  dates.map(({ regionName, dataFieldName }) =>
                    dispatch(
                      setSpecifiedDataFieldProperty({
                        regionName,
                        dataFieldName,
                        propertyName: 'value',
                        propertyData: {
                          value: dateString,
                        },
                      }),
                    ),
                  )
                }}
                style={{ width: '1.2rem', height: '1.2rem' }}
              />
              <label className="m-0 cursor-pointer" htmlFor="show-label-en">
                Hiển thị song ngữ Việt-Anh
              </label>
            </div>
          </div>
          <div className="col-12 px-0">
            <div className="d-flex flex-row align-items-center cursor-pointer">
              <input
                className="mr-3 cursor-pointer"
                type="checkbox"
                id="show-watermark-in-adjusted-invoice"
                checked={isShowWatermarkInAdjustedInvoice}
                onChange={(e) => {
                  let value = e.target.checked
                  dispatch(
                    setInstanceInfo({
                      isShowWatermarkInAdjustedInvoice: value,
                    }),
                  )

                  dispatch(
                    setWatermarkInfo({
                      opacity: 50,
                    }),
                  )

                  dispatch(setShowWatermark(false))
                }}
                style={{ width: '1.2rem', height: '1.2rem' }}
              />
              <label
                className="m-0 cursor-pointer"
                htmlFor="show-watermark-in-adjusted-invoice"
              >
                Hiển thị dấu chìm trên hóa đơn bị điều chỉnh
              </label>
            </div>

            {isShowWatermarkInAdjustedInvoice && (
              <div className="ml-15">
                <div
                  className="d-flex flex-row justify-content-between align-items-center"
                  style={{
                    width: '300px',
                  }}
                >
                  <p className="mb-0">Độ nét của dấu</p>
                  <output id="output" className="ml-5">{`${[
                    watermarkInfo?.opacity || 0,
                  ]}%`}</output>
                </div>
                <div
                  className="d-flex justify-content-center flex-wrap mb-3"
                  style={{
                    width: '300px',
                  }}
                >
                  <Range
                    values={[watermarkInfo?.opacity || 0]}
                    step={1}
                    min={0}
                    max={100}
                    onChange={(values) =>
                      dispatch(
                        setWatermarkInfo({
                          opacity: values[0],
                        }),
                      )
                    }
                    renderTrack={({ props, children }) => (
                      <div
                        onMouseDown={props.onMouseDown}
                        onTouchStart={props.onTouchStart}
                        className="d-flex w-100"
                        style={{
                          ...props.style,
                          height: '20px',
                        }}
                      >
                        <div
                          ref={props.ref}
                          className="w-100 align-self-center"
                          style={{
                            height: '5px',
                            borderRadius: '4px',
                            background: getTrackBackground({
                              values: [watermarkInfo?.opacity || 0],
                              colors: ['#548BF4', '#ccc'],
                              min: 0,
                              max: 100,
                            }),
                          }}
                        >
                          {children}
                        </div>
                      </div>
                    )}
                    renderThumb={({ props }) => (
                      <div
                        {...props}
                        style={{
                          ...props.style,
                          height: '5px',
                          width: '20px',
                          backgroundColor: '#FFF',
                          boxShadow: '0px 2px 6px #AAA',
                        }}
                      ></div>
                    )}
                  />
                </div>
                <div className="d-flex flex-row align-items-center cursor-pointer">
                  <input
                    className="mr-3 cursor-pointer"
                    type="checkbox"
                    id="show-watermark"
                    checked={showWatermark}
                    onChange={(e) => {
                      let value = e.target.checked

                      dispatch(setShowWatermark(value))
                    }}
                    style={{ width: '1.2rem', height: '1.2rem' }}
                  />
                  <label
                    className="m-0 cursor-pointer"
                    htmlFor="show-watermark"
                  >
                    Xem trước cách hiển thị
                  </label>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default GeneralControl
